// extracted by mini-css-extract-plugin
export var downArrow = "_9x-0";
export var label = "_9x-1";
export var treatmentCard = "_9x-3";
export var upArrow = "_9x-2";